/**
 * Grid card for an upcoming live session.
 */
import React from "react";
import { Icon } from "@iconify/react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

import { VAvatar, VButton, VText } from "form";
import BThumb from "./BThumb";
import { getFormatDate, getShortTime } from "utils/date";

/**
 * Live-session tile with tutor avatar, schedule, and a Jitsi join link.
 *
 * @param {{ session: Object, disabled?: boolean }} props
 */
const BZoomGridItem = (props) => {
  const { session, disabled } = props;

  const { t, i18n } = useTranslation("common");

  return (
    <Box className="w-full border border-solid border-gray-300 dark:border-gray-500 rounded-md h-full flex flex-col">
      <Box className="flex flex-col w-full relative">
        <BThumb src={`${process.env.REACT_APP_S3_ASSET_ENDPOINT}/v2-assets/app/video1.png`} error="" className="w-full aspect-[5/3] rounded-md" />
        <Box className="flex items-end -mt-11 lg:-mt-14 ml-4">
          <VAvatar src={session.tutor_avatar} className="w-20 h-20 lg:w-24 lg:h-24" />
          <VText className="text-lg text-limit-1">{session.tutor_name}</VText>
        </Box>
      </Box>
      <Box className="p-4 flex flex-col gap-1">
        <VText div className="text-limit-2">
          {session?.topic || "-"}
        </VText>
        <div>
          <VText color="secondary" className="flex items-center text-xs">
            <Icon icon="lucide:clock-9" />
            &nbsp;
            {getFormatDate(session.start_time, i18n.language)} - {getShortTime(session.start_time)}
          </VText>
          <VText color="secondary" className="flex items-center text-xs">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{session.duration} min
          </VText>
        </div>
      </Box>
      <Box className="p-4 mt-auto">
        {disabled ? (
          <VButton variant="contained" color="primary" className="w-full normal-case" disabled>
            {t("Join")}
          </VButton>
        ) : (
          <a href={`${process.env.REACT_APP_JITSI_DOMAIN}/start/${process.env.REACT_APP_SITE_NAME}/${session.room}`} className="no-underline w-full" rel="noreferrer" target="_blank">
            <VButton variant="contained" color="primary" className="w-full normal-case">
              {t("Join")}
            </VButton>
          </a>
        )}
      </Box>
    </Box>
  );
};

BZoomGridItem.propTypes = {
  session: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default BZoomGridItem;
